<footer class="main-app-footer d-none">
    <div class="container-elements">
        <h5 class="main-text"> ¿Necesitas ayuda? </h5>
        <p class="main-description">Un asesor está disponible para atenderte</p>
        <a target="_blank" href="https://bit.ly/3y9jMmC" class="footer-whatsapp text-white">
            <i class="fa fa-whatsapp" aria-hidden="true"></i>
            Chatear con un asesor
        </a>
    </div>
</footer>